import {
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_AGE,
  MIN_PASSWORD_LENGTH,
} from '@/constants/Common'
import { LocaleConstant } from '../en/constant'
const constant: LocaleConstant = {
  emailInvalid: '無效的郵件地址。',
  emailRequired: '需要電子郵件。',
  passRequired: '密碼是必需的。',
  passNoWhiteSpace: '不允許有空格。',
  passMinLength: `密碼長度必須至少為 ${MIN_PASSWORD_LENGTH} 字元。`,
  passMaxLength: `密碼不得超過 ${MAX_PASSWORD_LENGTH} 個字元。`,
  passLettersNumbers: '密碼必須包含字母和數字',
  passOneNumbers: '密碼必須包含至少一個數字',
  passStrength: `密碼必須至少包含 ${MIN_PASSWORD_LENGTH} 個字符，其中包含大寫或小寫字母和數字的組合。`,
  passMatch: '請輸入符合的密碼。',
  fullNameRequired: '需要全名。',
  fullNameNoSpecial: '不允許使用數字或特殊字元。',
  fullNameNoWhitespace: '僅不允許使用空格。',
  fullNameMaxLength: `只允許使用 ${MAX_FULL_NAME_LENGTH} 個字元`,
  nameMaxLength: `只允許使用 ${MAX_NAME_LENGTH} 個字元`,
  typeDate: '日期格式應為月/日/年',
  birthDateRequired: '出生日期為必填。',
  birthDateMin: `最低年齡為 ${MIN_AGE} 歲。`,
  emailConfirm: '電子郵件內容不符。',
  locationRequired: '位置為必填項',
  locationNeedsCity: '請選擇一個城市或城鎮。僅選擇國家是不夠的。',
  locationSaveFailed: '無法使用該位置。請重試或選擇其他位置。',
}

export default constant
